import { DefaultCarouselView } from '../../../../../../../api/custom-pages.dao';

export const defaultCarouselViewOptions = [
    { value: DefaultCarouselView.ShowAll, label: 'Show All' },
    { value: DefaultCarouselView.Collapsed, label: 'Collapsed' },
];